// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2FMrL","container":"styles_container__pKDff","title":"styles_title__kp7GP","wrapper":"styles_wrapper__SrV2V","answer":"styles_answer__3HYcd"};